module.exports = __webpack_public_path__ + "media/images/85/sleep_apnea_get_good_sleep-dc5d37c4de5da44e8cc86e91290f6948.jpg";